
function getPosition (node, scope) {
    const root = scope || document;
    const width = node.clientWidth
    const height = node.clientHeight
    let offsetTop  = node.offsetTop;
    let offsetLeft = node.offsetLeft;
    while (node && node.offsetParent && node.offsetParent != document && node !== root && root !== node.offsetParent ) {
        offsetTop += node.offsetParent.offsetTop;
        offsetLeft += node.offsetParent.offsetLeft;
        node = node.offsetParent;
    }
    return {
        top: offsetTop,
        left: offsetLeft,
        width, 
        height
    };
}




export default class ScrollObject extends HTMLElement {

    constructor() {

        super();

        this.intersectionObserver = new IntersectionObserver((entries)=>{
            entries.forEach((el)=>{
                if (el.isIntersecting) {
                    el.target.classList.add('in-view')
                }
                else {
                    el.target.classList.remove('in-view')
                }
            });
        });
        
        const noScale  = this.hasAttribute('no-scale')
        const parallax = this.hasAttribute('parallax');
        const offset   = Number(this.getAttribute('offset'))
        const ratio    = Number(this.getAttribute('ratio')) || 0.1
        

        // const darkTheme = this.hasAttribute('dark-theme');

        this.data  = {
            darkTheme: false, 
            parallax,
            noScale, ratio, offset, 
            winH: 0, top: 0, left: 0, 
            width: 0, height: 0,
        }

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.update   = this.update.bind(this);
        this.__scrollTop  = 0;
    }
    connectedCallback() {
        this.isAttached = true

        this.intersectionObserver.observe(this);

        if (this.data.parallax || this.data.darkTheme) {
            document.addEventListener('scroll', this.onScroll);
            window.addEventListener('resize',   this.onResize);
            this.resizeObserver = new ResizeObserver(e => {
                this.onResize()
            });
            this.resizeObserver.observe(this);
            this.resizeObserver.observe(document.body);
            this.update();
        }

    }

    disconnectedCallback() {
        this.isAttached = false
        this.intersectionObserver.unobserve(this);
        if (this.data.parallax || this.data.darkTheme) {
            document.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize',   this.onResize);
            this.resizeObserver.unobserve(this);
            this.resizeObserver.unobserve(document.body);
        }
    }
    onScroll(e) {
        this.__scrollTop = window.pageYOffset
    }
    onResize() {

        if (this.data.parallax || this.data.darkTheme) {
            let {top, left, width, height} = getPosition(this)
            this.data.top    = top;
            this.data.left   = left;
            this.data.width  = width;
            this.data.height = height;
            this.data.winH   = window.innerHeight;
        }
    }
    update() {

        if (!this.isAttached) {
            return
        }
        requestAnimationFrame(this.update);

        if (this.data.parallax) {
            let {top, height, noScale, ratio, offset, winH} = this.data
            if ( top - this.__scrollTop < winH) {
                let r = (top - (this.__scrollTop) + height + offset*winH) / (winH + height)
                r = Math.min(1, Math.max(0, r))
                this.style.transform = `translateY(${ (r-0.5) * 2 * height * ratio }px) scale(${noScale?'1':'1.2'}) translateZ(0)`
            }
        }

        // if (this.data.darkTheme) {
        //     let {top, height, noScale, ratio, offset, winH} = this.data
        //     if ( top - this.__scrollTop < 35 && top - this.__scrollTop > -height + 35 ) {
        //         //document.querySelector('app-header')?.classList.add('is-dark-theme');
        //     }
        //     else {
        //         //document.querySelector('app-header')?.classList.remove('is-dark-theme');
        //     }
        // }
        
    }
}
customElements.define('scroll-object', ScrollObject);